import { useMutation } from '@tanstack/react-query';
import type { UseMutationResult } from '@tanstack/react-query';
import { bffPost } from '../bff-api/bff';
import type { RecaptchaFeature, RecaptchaPayload } from './recaptcha';

export interface RecaptchaVerifyRequest {
    recaptcha: RecaptchaPayload & {
        feature: RecaptchaFeature;
    };
}

export const useRecaptchaVerify = (): UseMutationResult<unknown, unknown, RecaptchaVerifyRequest> =>
    useMutation<unknown, Error, RecaptchaVerifyRequest>({
        mutationFn: async (request: RecaptchaVerifyRequest) =>
            bffPost('/recaptcha/verify', {
                body: request,
            }),
    });
